module.exports = __webpack_public_path__ + "3b09331a965ff6a1e0428e091618b5d8.woff2";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/roboto/roboto-light.woff2
// module id = 1066
// module chunks = 0